import { render, staticRenderFns } from "./IndexAssureur.vue?vue&type=template&id=74cc95d3&"
import script from "./IndexAssureur.vue?vue&type=script&lang=js&"
export * from "./IndexAssureur.vue?vue&type=script&lang=js&"
import style0 from "./IndexAssureur.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports